import { DatePipe } from '@angular/common';
import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute,Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PrescriptionFulfillmentTypeEnum } from 'src/app/enums/prescription-fulfillment-type-enum';
import { PrescriptionRequestStatusEnum } from 'src/app/enums/prescription-request-status-enum';
import { getActualDate } from 'src/app/helpers/get-actual-time';
import { sortTable } from 'src/app/helpers/sort-table';
import { ColumnSortingDirective } from 'src/app/_directives/column-sorting.directive';
import { IColumnSortEvent } from 'src/app/_interfaces/i-column-sort-event';
import { IPrescriptionRequest } from 'src/app/_interfaces/prescription/i-prescription-request';
import { ISmartTablePagination } from 'src/app/_interfaces/smart-table/i-pagination';
import { PrescriptionService } from 'src/app/_services/prescription-fulfillment/prescription.service';
import * as XLSX from 'xlsx';
import { TableColumn } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-prescription-fulfillment-requests',
  templateUrl: './prescription-fulfillment-requests.component.html',
  styleUrls: ['./prescription-fulfillment-requests.component.scss'],
})
export class PrescriptionFulfillmentRequestsComponent implements OnInit {
  pageTitle: string = 'Prescription Fulfillment';
  searchString: string = null;
  filterTypes;
  prescriptionArray: IPrescriptionRequest[] = [];
  filteredPrescriptionArray: IPrescriptionRequest[] = [];
  invertSort: boolean = false;
  tableTitle: string = 'All Requests';
  noMatchingResult: boolean = false;
  currentPage: number = 1;
  pageSize: number = 10;
  totalPages: number;
  totalItems: number;
  prescriptionForm: FormGroup;
  currentDate: Date = new Date();
  maxDate: Date = new Date();
  prescriptionRequestStatusEnum = PrescriptionRequestStatusEnum;
  prescriptionStatus;
  isFromSearch: boolean = false;
  pageId: number;
  fulfillmentType: string;
  columns: TableColumn[];
  rows: IPrescriptionRequest[];

  constructor(
    private prescriptionService: PrescriptionService,
    public toastr: ToastrService,
    private router: Router,
    private activatedRoute:ActivatedRoute,
    private formBuilder: FormBuilder,
    private datePipe: DatePipe
  ) {
    this.currentDate.setFullYear(this.currentDate.getFullYear() - 1);
    this.currentDate.setMonth(this.currentDate.getMonth() + 9);
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.prescriptionStatus = this.prescriptionRequestStatusEnum.All;
    this.filterTypes = [
      { key: 'All', value: this.prescriptionRequestStatusEnum.All },
      {
        key: 'Pending Requests',
        value: this.prescriptionRequestStatusEnum.Pending,
      },
      {
        key: 'In progress Requests',
        value: this.prescriptionRequestStatusEnum.InProgress,
      },
      {
        key: 'Finished Requests',
        value: this.prescriptionRequestStatusEnum.Finished,
      },
    ];
  }

  ngOnInit(): void {
    this.prescriptionForm = this.formBuilder.group({
      prescriptionText: [''],
      prescriptionDuration: [null],
    });

    this.activatedRoute.params.subscribe(param => {
      this.fulfillmentType = param.type;
      this.currentPage = 1;
      this.pageSize = 10;
      let paramsObject = this.generatePrescriptionsParamas();
      this.getPrescriptionRequests(paramsObject, this.isFromSearch);
    });
  }

 getPrescriptionRequests(paramsObject, isFromSearch) {
  this.prescriptionService
    .getPrescriptionRequests(paramsObject)
    .subscribe((response) => {
      // Transform statusId to status string using handleRequestStatus
      this.prescriptionArray = response.data.items.map(item => {
        item.requestStatus = this.handleRequestStatus(item.requestStatusId);
        return item;
      });
      this.filteredPrescriptionArray = this.prescriptionArray;

      this.columns = [
        { prop: 'id', name: 'Request ID' },
        { prop: 'patientName', name: 'Patient Name' },
        { prop: 'patientPhone', name: 'Mobile No.' },
        { 
          prop: 'creationDate', 
          name: 'Request Date',
          pipe: { transform: (val) => this.datePipe.transform(val, "MMM d, y, h:mm a") }
        },
        { prop: 'isIncludeMedications', name: 'Includes medication' },
        { prop: 'isIncludeTests', name: 'Includes Tests' },
        { prop: 'isIncludeRadiologies', name: 'Includes Radiologies' },
        { prop: 'isIncludeHospitalProcedures', name: 'Includes Procedures' },
        { prop: 'requestStatus', name: 'Status' },  // Update to 'requestStatus' (mapped status)
      ];

      this.currentPage = response.data.pagination.currentPage;
      this.totalPages = response.data.pagination.totalPages;
      this.totalItems = response.data.pagination.totalItems;

      if (isFromSearch) {
        this.noMatchingResult = this.filteredPrescriptionArray.length
          ? false
          : true;
      }
    });
}


  onSearchPrescription() {
    this.currentPage = 1;
    this.filteredPrescriptionArray = [];
    this.searchString = this.prescriptionForm.value.prescriptionText;
    this.isFromSearch = true;

    let paramsObject = this.generatePrescriptionsParamas();

    this.getPrescriptionRequests(paramsObject, this.isFromSearch);
  }

  onSearchInputKeyup(searchString) {
    if (!searchString) {
      this.currentPage = 1;
      this.filteredPrescriptionArray = [];
      this.isFromSearch = true;

      let paramsObject = this.generatePrescriptionsParamas();

      this.getPrescriptionRequests(paramsObject, this.isFromSearch);
    }
  }

  onBtnSearchPrescription(status, tableTitle) {
    this.currentPage = 1;
    this.prescriptionStatus = status;
    this.filteredPrescriptionArray = [];
    this.isFromSearch = true;
    this.tableTitle = tableTitle == 'All' ? 'All Requests' : tableTitle;

    let paramsObject = this.generatePrescriptionsParamas();

    this.getPrescriptionRequests(paramsObject, this.isFromSearch);
  }

  handlePrescriptionPagination() {
    if (this.currentPage < this.totalPages) {
      this.currentPage += 1;
      this.isFromSearch = false;

      let paramsObject = this.generatePrescriptionsParamas();
      this.getPrescriptionRequests(paramsObject, this.isFromSearch);

    }
  }

  onChangePage(pageDetails: ISmartTablePagination ){

    this.currentPage = pageDetails.offset + 1;
    this.isFromSearch = false;

    let paramsObject = this.generatePrescriptionsParamas();

    this.getPrescriptionRequests(paramsObject, this.isFromSearch);
  }



generatePrescriptionsParamas() {
    const statusId = this.prescriptionStatus;
    const patientNameOrMobile = this.prescriptionForm.value.prescriptionText;
    let prescriptionTypeId: number;

    if(this.fulfillmentType == 'medicine') {
      prescriptionTypeId = PrescriptionFulfillmentTypeEnum.Medicine;
    }
    else if(this.fulfillmentType == 'labtest') {
      prescriptionTypeId = PrescriptionFulfillmentTypeEnum.LabTest;
    }
    else if(this.fulfillmentType == 'radiology') {
      prescriptionTypeId = PrescriptionFulfillmentTypeEnum.Radiology;
    }
    else {
      prescriptionTypeId = PrescriptionFulfillmentTypeEnum.HospitalProcedure;
    }

    let fromDate = null;
    let toDate = null;

    if (this.prescriptionForm.value.prescriptionDuration?.length) {
      fromDate = this.prescriptionForm.value.prescriptionDuration[0];
      toDate = this.prescriptionForm.value.prescriptionDuration[1];

      if (!fromDate || !toDate) {
        fromDate = null;
        toDate = null;
      } else {
        fromDate = fromDate?.toISOString();
        toDate = toDate?.toISOString();
      }
    }

    const currentPage = this.currentPage;
    const pageSize = this.pageSize;

    return {
      statusId,
      prescriptionTypeId,
      patientNameOrMobile,
      fromDate,
      toDate,
      currentPage,
      pageSize,
    };
}


  handleRequestStatus(status) {
    if (status == this.prescriptionRequestStatusEnum.All) {
      return 'All';
    } else if (status == this.prescriptionRequestStatusEnum.Pending) {
      return 'Pending';
    } else if (status == this.prescriptionRequestStatusEnum.InProgress) {
      return 'InProgress';
    } else if (status == this.prescriptionRequestStatusEnum.Finished) {
      return 'Finished';
    }

    return '--';
  }

  handlePrescriptionClick(requestId) {
    this.router.navigate(['prescription-fulfillment', requestId]);
  }

  onActivate(event) {
  if(event.type == 'click') {
    let requestId = event.row.id
    this.router.navigate(['prescription-fulfillment', requestId]);
  }
}

exportTOExcel(): void {
  let data: IPrescriptionRequest[] = [];
  let params = this.generatePrescriptionsParamas();

  // Fetch the data from the backend
  this.prescriptionService.getExportExcel(params.statusId, params.prescriptionTypeId).subscribe((res) => {
    // Transform requestStatusId to Status for export
    data = res.data.map(item => {
      // Map requestStatusId to Status using handleRequestStatus method
      item.Status = this.handleRequestStatus(item.requestStatusId);
      return item;
    });

    // Create a worksheet from the transformed data
    const ws = XLSX.utils.json_to_sheet(data);

    // Create a new workbook and append the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Write the Excel file
    XLSX.writeFile(wb, `Prescriptions - ${new Date().toLocaleString()}.xlsx`);
  });
}


  invertSorting() {
    this.invertSort = !this.invertSort;
    this.filteredPrescriptionArray = sortTable(
      this.filteredPrescriptionArray,
      'creationDate',
      this.invertSort
    );
  }
}

